<div class="row align-items-center">
  @if (showIcon) {
    <span nz-icon nzType="download" nzTheme="outline"></span>
  }
  <a nz-button nzType="link" (click)="download()" [class.break-text]="breakText" class="h-auto">{{ fileName }}</a>
</div>
